import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";
import {
  Text,
  Flex,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  Tooltip,
  TableContainer,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Textarea,
  SimpleGrid,
  useColorMode,
  useColorModeValue,
  Box,
  Input,
  Switch,
  Skeleton,
} from "@chakra-ui/react";
import ReactSelect from "react-select";
import axios from "axios";
import apiUrl from "variables/api";
import darkStyles from "variables/darkStyles";

import { toast } from "react-toastify";

function Page() {
  const [data, setData] = useState([]);
  const [current, setCurrent] = useState({value:0, label: "Wybierz..."});
//   const [currentData, setCurrentData] = useState([]);

  useEffect(() => {
    axios
      .get(apiUrl + "/data/changes-stats", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        setData(response.data);
        setCurrent(response.data.periods[0]);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  }, []);


  const getTotalCount = (changes) => {
    return changes?.reduce((total, change) => total + change.changeCount, 0);
  };

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <Flex justifyContent="space-between" alignItems="center">
          <Text fontSize="2xl">Statystyki zmian</Text>
        </Flex>
        <ReactSelect
          noOptionsMessage={() => "Brak dostępnych opcji"}
            options={data?.periods}
            placeholder="Wybierz..."
            styles={darkStyles()}
            value={current}
            onChange={setCurrent}
          />
          {data?.periods && (
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mt={4}>
          <Box>
            <Text fontSize="xl" fontWeight="bold">
              Zmiana I
            </Text>
            <TableContainer>
              <Table variant="striped">
                <Thead>
                  <Tr>
                    <Th>Nick</Th>
                    <Th>Liczba wyjazdów</Th>
                  </Tr>
                </Thead>
                <Tbody>
                {data && (
                    <Tr>
                      <Td>SUMA</Td>
                      <Td>{getTotalCount(data?.changeOneCount[current.value])}</Td>
                    </Tr>
                  )}
                  {data?.changeOneCount[current.value]?.map((change) => (
                    <Tr key={change.id}>
                      <Td>{change.nick}</Td>
                      <Td>{change.changeCount}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
          <Box>
            <Text fontSize="xl" fontWeight="bold">
              Zmiana II
            </Text>
            <TableContainer>
              <Table variant="striped">
                <Thead>
                  <Tr>
                    <Th>Nick</Th>
                    <Th>Liczba wyjazdów</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {data && (
                    <Tr>
                      <Td>SUMA</Td>
                      <Td>{getTotalCount(data?.changeTwoCount[current.value])}</Td>
                    </Tr>
                  )}
                  {data?.changeTwoCount[current.value]?.map((change) => (
                    <Tr key={change.id}>
                      <Td>{change.nick}</Td>
                      <Td>{change.changeCount}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
          <Box>
            <Text fontSize="xl" fontWeight="bold">
                Osoby bez roli zmiany
            </Text>
            <TableContainer>
                <Table variant="striped">
                    <Thead>
                        <Tr>
                            <Th>Nick</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data?.membersWithoutRoles?.map((change) => (
                            <Tr key={change.id}>
                                <Td>{change.nick}</Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </TableContainer>
          </Box>
        </SimpleGrid>
        )}
      </Card>
    </Flex>
  );
}

export default Page;
